import React from 'react';
import Anime, { anime } from 'react-anime';
import './EndPipes.scss';
import ImageCircle from './ImageCircle';
export default () => {
  const circlesList = [
    { title: 'Kidney Disease', size: 'small', yCoord: 2, xCoord: 25, hideMobile: 'hide-desktop' },
    { title: 'Cardiovascular Disease',  size: '', yCoord: 1, xCoord: 3 },
    { title: 'Transplant Medicine',  size: '', yCoord: 57, xCoord: 1 },
    { title: 'Autoimmunity',  size: '', yCoord: 2, xCoord: 60 },
    { title: 'Liver Disease',  size: 'small', yCoord: 55, xCoord: 77 },
    { title: 'Gene Therapy',  size: 'small', yCoord: 65, xCoord: 28, hideMobile: 'hide-desktop' },
    { title: 'Skin Disorders',  size: 'small', yCoord: 22, xCoord: 6},
    { title: 'Lung Disease',  size: 'small', yCoord: 2, xCoord: 45 },
    { title: 'Brain Disease',  size: 'small', yCoord: 11, xCoord: 35 },
    { title: 'Blood Disease',  size: 'small', yCoord: 1, xCoord: 90, hideMobile: 'hide-desktop' },
    { title: 'Eye Disease',  size: 'small', yCoord: 75, xCoord: 40, hideMobile: 'hide-desktop' },
    { title: 'Cancer',  size: 'small', yCoord: 20, xCoord: 80 },
  ];
  const animateCircles = {
    top: [
      { value: () => '25%', duration: 0 },
      { value: (el, i) => {
        return circlesList[i].yCoord;
      }, easing: 'easeInOutElastic', duration: 0, delay: anime.stagger(15)}
    ],
    left: [
      { value: () => '25%', duration: 0 },
      { value: (el, i) => {
        return circlesList[i].xCoord;
      }, easing: 'easeInOutElastic', duration: 0, delay: anime.stagger(15)}
    ],
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 500, easing: 'linear'}
    ],
  };

  const CreateCircles = () => (
    <div className="random-circles">
      <div className="circle-container">
        <Anime {...animateCircles}>
          {circlesList && circlesList.map((circle, i) => {
            return (
              <div key={`${i}-1`}
                className={`circle-cover circle-cover-${i} ${circle.size} ${circle.hideMobile}`}>
                <div className="inner-circles">
                  <p>{circle.title}</p>
                </div>
              </div>
            );
          })}
        </Anime>
      </div>
    </div>
  );
  return (
    <div className="end-pipes">
      <CreateCircles />
        <ImageCircle />
    </div>
  );
}